import React, { useState, useEffect, useContext } from "react";
import { nextDocument } from "react-doc-viewer/build/state/actions";
import { Link, NavLink } from 'react-router-dom';
import { Button } from 'reactstrap';
import EventContext from "../../contexts/event";
import {useIntl} from "react-intl";

const ScreenBottomBar: React.FC<{
  usersLength:number;
  presentationId?:string;
  answersLength:number;

}>=({usersLength, answersLength,presentationId}) => {

    const intl = useIntl();

/* default bottom bar in quiz pages */
  return (
    <div className="quiz-controls">
      <div className="connected-users-answers">
          <div className="common"><span>{usersLength}</span> {intl.formatMessage({ id: "quiz.connected" })}</div>
          <div className="seperator"></div>
          <div className="common"><span>{answersLength}</span> {intl.formatMessage({ id: "quiz.answers" })}</div>
      </div>
      <div className="controls" style={{height:100}}>


      </div>
    </div>
  )
}

export default ScreenBottomBar;


